import React from 'react';
import MainMenuComponent from '../../Components/Menus/MainMenuComponent';

function ManagementTaskPage() {
  return <MainMenuComponent menuName="sop" />;
}

export default ManagementTaskPage;
